/**
 * Filtros de grupo e cota da pipeline de pós-venda (busca por trecho de texto)
 */

import { KanbanBoard, PipelineCard } from '../types';

export function cardGrupo(card: PipelineCard): string {
  const numero = card.contratos?.grupos?.numero_grupo;
  return numero != null ? String(numero) : '';
}

export function cardCota(card: PipelineCard): string {
  return (card.contratos?.cota || '').trim();
}

function matchesTerm(value: string, term: string): boolean {
  const t = term.trim().toLowerCase();
  if (!t) return true;
  return value.toLowerCase().includes(t);
}

/** Busca livre: o termo casa com o grupo ou com a cota do card */
export function searchMatchesGrupoOuCota(card: PipelineCard, term: string): boolean {
  if (!term.trim()) return false;
  return matchesTerm(cardGrupo(card), term) || matchesTerm(cardCota(card), term);
}

export function matchesGrupoCota(card: PipelineCard, grupo: string, cota: string): boolean {
  return matchesTerm(cardGrupo(card), grupo) && matchesTerm(cardCota(card), cota);
}

/** Valores distintos de grupo e cota presentes no board, para o dropdown dos AutoCompletes */
export function buildGrupoCotaOptions(board: KanbanBoard | undefined) {
  const grupos = new Set<string>();
  const cotas = new Set<string>();

  board?.stages.forEach((swc) =>
    swc.cards.forEach((card) => {
      const grupo = cardGrupo(card);
      const cota = cardCota(card);
      if (grupo) grupos.add(grupo);
      if (cota) cotas.add(cota);
    })
  );

  const sortNatural = (a: string, b: string) => a.localeCompare(b, 'pt-BR', { numeric: true });
  const toOptions = (values: Set<string>) =>
    [...values].sort(sortNatural).map((value) => ({ value }));

  return { grupoOptions: toOptions(grupos), cotaOptions: toOptions(cotas) };
}
